module.exports = __webpack_public_path__ + "static/img/Property-right.776cd5f5.svg";